
import Vue from 'vue'
const KnowledgeCheckEvents = new Vue();

// This components is a event bus to hanndle events between quizOptions and KnoledgeChecks,
// keep in mind that is not been used to share states, but to share events, if you need to
// share states between components use a Vuex store instead.

export default KnowledgeCheckEvents;
